import { Box, Typography, Stack, Select, MenuItem, Checkbox, SelectChangeEvent, Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useMemo } from "react";
import { defaultAgesFromList, defaultAgesToList } from "~/shared/const/app";
import { AgeInputProps } from "~/shared/types/types";

const formatAgeOption = (age: number | string) => age === 65 ? '65+' : age;

export const AgeInput = ({
  ageFrom,
  onChangeFrom,
  ageTo,
  onChangeTo,
  unspecified_age,
  onChangeUnspecifiedAge
}: AgeInputProps) => {
  const ageLists = useMemo(
    () => ({
      from: ageTo
        ? defaultAgesFromList.filter(i => i <= Number(ageTo)) : defaultAgesFromList,
      to: ageFrom
        ? defaultAgesToList.filter(i => i >= Number(ageFrom)) : defaultAgesToList,
    }),
    [ageFrom, ageTo],
  );

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography fontWeight={600} variant="subtitle2">Возраст</Typography>
      <Stack direction="row" gap={1} alignItems="center">
        <Box flex={1}>
          <Typography variant="caption" color="textSecondary">От</Typography>
          <Select
            fullWidth
            value={ageFrom as any}
            onChange={onChangeFrom}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return <Typography color="textSecondary">Не выбрано</Typography>;
              }
              return formatAgeOption(selected);
            }}
          >
            <MenuItem value="">Не выбрано</MenuItem>
            {ageLists.from.map(age => (
              <MenuItem key={age} value={age}>
                {formatAgeOption(age)}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box flex={1}>
          <Typography variant="caption" color="textSecondary">До</Typography>
          <Select
            fullWidth
            value={ageTo as any}
            onChange={onChangeTo}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return <Typography color="textSecondary">Не выбрано</Typography>;
              }
              return formatAgeOption(selected);
            }}
          >
            <MenuItem value="">Не выбрано</MenuItem>
            {ageLists.to.map(age => (
              <MenuItem key={age} value={age}>
                {formatAgeOption(age)}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box display="flex" alignItems="center" mt={2.5}>
          <Checkbox
            checked={unspecified_age}
            onChange={onChangeUnspecifiedAge}
          />
          <Typography>Unknown</Typography>
          <Tooltip title="Включает пользователей, чей возраст не определен Google">
            <IconButton size="small">
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>
    </Box>
  );
}
